import { SupportTokenAction as o } from "../../constants/config.js";
import { currencyTokenAssetNameSchema as n } from "../../../currency-lib/deserialize/yup/currency.js";
import { conjunctItemSchema as d } from "../../../planet-lib/deserializes/yup/conjunct.js";
import * as r from "ramda";
import * as e from "yup";
const m = e.object({
  age: e.number().default(0),
  slot: e.number().default(0)
}).from("slot_count", "slot").noUnknown(!0), s = e.object({
  consumeApostleMax: e.number().default(0)
}).from("consume_apostle_max", "consumeApostleMax").noUnknown(!0), i = e.object({
  cooldown: e.number().default(0)
}).noUnknown(!0), u = e.object({
  cooldown: e.number().default(0),
  max: e.number().default(5),
  breedCost: e.array().of(e.array().of(d)).default([]),
  breedCostTable: e.object()
}).from("max_count", "max").from("breed_cost", "breedCost").from("breed_cost_table", "breedCostTable").noUnknown(!0), p = e.object({
  apostleSlotTable: e.array().of(m).default([]),
  maxActiveSkill: e.number().default(3),
  maxAge: e.number().default(0)
}).from("age_to_relic_apostle_slot", "apostleSlotTable").from("max_active_skill", "maxActiveSkill").from("max_age", "maxAge").noUnknown(!0), b = e.object({
  assets: e.array().of(e.string()).default([])
}).from("related_asset", "assets"), _ = e.lazy((t) => {
  const f = r.reduce(
    (c, l) => ({
      ...c,
      [l]: b
    }),
    {},
    r.keys(t)
  );
  return e.object(f);
}), g = e.object({
  maxManageCount: e.number().default(0),
  maxSelectedPlanet: e.number().default(0)
}).from("max_manage_count", "maxManageCount").from("max_selected_planet", "maxSelectedPlanet").noUnknown(!0), P = e.object({
  cooldown: e.number().default(0)
}).from("born_cooldown_in_second", "cooldown").noUnknown(!0), h = e.object({
  endTime: e.string().required().default(""),
  isMaintenance: e.boolean().default(!1),
  paths: e.array().of(e.string().required()).default([""])
}).camelCase().noUnknown(!0), C = e.object({
  cooldown: e.number().default(0),
  cooldownPlanet: e.number().default(0),
  fee: e.number().default(0),
  maxAttachEachTime: e.number().default(0),
  maxDuration: e.number().default(0),
  minDuration: e.number().default(0)
}).from("attach_planet_to_star_max", "maxAttachEachTime").from("planet_attach_cooldown", "cooldownPlanet").from("platform_fee", "fee").from("rental_cool_down_in_hr", "cooldown").from("rental_duration_max_in_day", "maxDuration").from("rental_duration_min_in_day", "minDuration"), y = e.object({
  assetNames: e.array().of(e.string()).default([])
}).from("claimable_asset_name", "assetNames"), k = e.object().shape({
  createOrderTypedDataErc1155: e.object().required(),
  createOrderTypedDataErc721: e.object().required()
}).transform((t) => ({
  createOrderTypedDataErc1155: JSON.parse(t.create_order_typed_data_erc1155) || {},
  createOrderTypedDataErc721: JSON.parse(t.create_order_typed_data_erc721) || {}
})).default({
  createOrderTypedDataErc1155: {},
  createOrderTypedDataErc721: {}
}), S = e.object({
  onToOffChain: e.array().of(
    e.object({
      off: e.string().required(),
      on: e.string().required(),
      ratio: e.number().required()
    })
  )
}).from("on_to_off_chain", "onToOffChain").default({
  onToOffChain: []
}), j = e.object({
  conversion: S
}).default({
  conversion: {
    onToOffChain: []
  }
}), T = e.object().shape({
  planetBreed: e.object()
}).from("planet_breed", "planetBreed").default({
  planetBreed: {}
}), x = e.object().shape({
  apostle: e.object()
}).default({
  apostle: {
    postMessage: [],
    supportedCurrencies: []
  }
}), a = e.object({
  onChain: e.array().of(e.string()).default([]),
  offChain: e.array().of(e.string()).default([])
}).from("on_chain", "onChain").from("off_chain", "offChain"), w = e.object({
  [o.AccountHeaderToken]: a,
  [o.AllToken]: a,
  [o.DailyCheckIn]: e.array().of(e.string()).default([]),
  [o.VipShop]: e.array().of(e.string()).default([]),
  [o.Unspecified]: e.array().of(e.string()).default([])
}).from("account_header_tokens", o.AccountHeaderToken).from("all_tokens", o.AllToken).from("daily_checkin", o.DailyCheckIn).from("vip_shop", o.VipShop), A = e.object({
  level: e.number().default(0),
  rate: e.array().of(e.string()).default([]),
  scaler: e.number().default(0)
}).from("monthly_scaler", "scaler"), v = e.object({
  duration: e.array().of(e.number()).default([]),
  data: e.array().of(A).default([])
}).from("table_data", "data"), O = e.object({
  aprTable: v,
  percentage: e.array().of(
    e.object({
      boostRatio: e.number().default(0),
      duration: e.number().default(0)
    }).from("boost_ratio", "boostRatio").from("duration_in_second", "duration")
  ),
  supportStakeTokens: e.array().of(
    e.object({
      currencyCode: n,
      opRatio: e.number().default(0)
    }).from("asset_name", "currencyCode").from("op_ratio", "opRatio")
  ),
  supportGetTokens: e.array().of(
    e.object({
      from: n,
      to: e.array().of(n).required()
    })
  ),
  levelChart: e.array().of(
    e.object({
      minOrderlyPoint: e.number().default(0)
    }).from("min_orderly_point", "minOrderlyPoint")
  )
}).from("apr_rating_table", "aprTable").from("level_chart", "levelChart").from("support_get_tokens", "supportGetTokens").from("support_stake_tokens", "supportStakeTokens").default({
  supportGetTokens: [],
  supportStakeTokens: []
}), U = e.object({
  apostleMerge: s,
  apostleMintConfig: e.array().of(e.object()).default([]),
  attach: i,
  bounty: x,
  breed: u,
  currency: j,
  discount: T,
  i18nLookup: e.object().shape({}).default({}),
  maintenance: e.array().of(h).default([]),
  managePlanetApostle: g,
  orbitRental: C,
  planet: p,
  relatedAsset: _,
  rewardCenter: y,
  roninMarketplace: k,
  supportToken: w,
  vipLevel: O
}).from("frontendConfig.apostle_merge", "apostleMerge").from("frontendConfig.attach", "attach").from("frontendConfig.breed", "breed").from("frontendConfig.currency", "currency").from("frontendConfig.discount", "discount").from("frontendConfig.i18n_lookup", "i18nLookup").from("frontendConfig.maintenance", "maintenance").from("frontendConfig.manage_planet_apostle", "managePlanetApostle").from("frontendConfig.planet", "planet").from("frontendConfig.rental_orbital_track", "orbitRental").from("frontendConfig.related_asset", "relatedAsset").from("frontendConfig.reward_center", "rewardCenter").from("frontendConfig.ronin_marketplace", "roninMarketplace").from("frontendConfig.support_token", "supportToken").from("frontendConfig.vip_level", "vipLevel").noUnknown(!0);
export {
  s as frontendApostleMergeConfigSchema,
  i as frontendAttachConfigSchema,
  P as frontendBornConfigSchema,
  u as frontendBreedConfigSchema,
  U as frontendConfigSchema,
  j as frontendCurrencyConfigSchema,
  S as frontendCurrencyConversionConfigSchema,
  h as frontendMaintenanceSchema,
  g as frontendManagePlanetApostleConfigSchema,
  C as frontendOrbitRentalConfigSchema,
  p as frontendPlanetConfigSchema,
  y as frontendRewardCenterConfigSchema,
  k as frontendRoninMarketplaceConfigSchema
};
//# sourceMappingURL=config.js.map
